/**
 * Created by Carsten Bühler
 * User: CBuehler on 08.12.2015
 * Copyright: xdot GmbH 2015
 */

import keyMirror from 'external/keymirror';

export const ClassNames = keyMirror({
    JournalEntry: null
});

export const JournalEntryCategories = keyMirror({
    CHANGE_RECORD: null,
    ALARMLEVEL_SET: null,
    ALARMLEVEL_MANUAL: null,
    OPERATION_PLANNING: null,
    TASK_MANAGEMENT: null,
    ACTIVATION_MATRIX: null,
    SITUATION_MESSAGE: null,
    SITUATION_MAP: null,
    FRB_CHART: null,
    WATER_LEVEL_CHART: null,
    PRECIPITATION_STATION_CHART: null,
    REAL_PRECIPITATION_STATION_CHART: null,
    WEBCAM: null,
    WEATHER_WARNING: null,
    WATERLEVEL_MESSAGE: null,
});

export const MAX_JOURNAL_FILTER_DATE_RANGE_DAYS = 14;



// WEBPACK FOOTER //
// ./js/constants/Constants.js